import React, { useEffect, useState, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, AlertTriangle, Biohazard } from "lucide-react";

const ALERTS = [
  { title: "PATHOGEN DETECTED", body: "Cyclospora cayetanensis found on your cursor. Do not lick your screen." },
  { title: "SYSTEM QUARANTINE", body: "This browser tab has been exposed. Symptoms may begin in 7 business days." },
  { title: "BIOHAZARD BREACH", body: "Containment failed. The oocysts are loose. There is no undo button." },
  { title: "GUT FLORA ALERT", body: "Your microbiome just filed a formal complaint against you." },
  { title: "CODE BROWN", body: "Emergency protocol activated. Please remain within 4 meters of a restroom." },
];

let idc = 0;

export const FakeWarningPopups = () => {
  const [popups, setPopups] = useState([]);

  const spawn = useCallback(() => {
    const a = ALERTS[Math.floor(Math.random() * ALERTS.length)];
    const top = 12 + Math.random() * 60;
    const left = 6 + Math.random() * 66;
    const id = ++idc;
    setPopups((p) => [...p.slice(-3), { ...a, id, top, left }]);
  }, []);

  useEffect(() => {
    const first = setTimeout(spawn, 6000);
    const interval = setInterval(spawn, 16000);
    return () => {
      clearTimeout(first);
      clearInterval(interval);
    };
  }, [spawn]);

  const close = (id) => setPopups((p) => p.filter((x) => x.id !== id));

  return (
    <div className="pointer-events-none fixed inset-0 z-50" data-testid="fake-popups">
      <AnimatePresence>
        {popups.map((p) => (
          <motion.div
            key={p.id}
            initial={{ opacity: 0, scale: 0.6, rotate: -6 }}
            animate={{ opacity: 1, scale: 1, rotate: 0 }}
            exit={{ opacity: 0, scale: 0.6, y: 20 }}
            drag
            dragMomentum={false}
            className="pointer-events-auto absolute w-72 bg-[#0a133f] border-4 border-[#d9b3ff] shadow-[8px_8px_0_#000] cursor-grab active:cursor-grabbing"
            style={{ top: `${p.top}%`, left: `${p.left}%` }}
            data-testid={`fake-popup-${p.id}`}
          >
            <div className="hazard-tape h-2" />
            <div className="flex items-center justify-between bg-[#b026ff] px-2 py-1">
              <span className="flex items-center gap-1 font-mono2 text-[10px] font-bold text-[#0a133f] uppercase">
                <AlertTriangle size={12} /> Windows Diarrhea XP
              </span>
              <button onClick={() => close(p.id)} className="text-[#0a133f] hover:text-white" data-testid={`fake-popup-close-${p.id}`}>
                <X size={14} />
              </button>
            </div>
            <div className="p-3 flex gap-3 items-start">
              <Biohazard className="w-10 h-10 shrink-0 spin-slow" style={{ color: "#d9b3ff" }} />
              <div>
                <p className="stencil-pink text-base leading-tight">{p.title}</p>
                <p className="font-mono2 text-[11px] text-white/80 mt-1">{p.body}</p>
              </div>
            </div>
            <div className="flex gap-2 p-2 pt-0">
              <button onClick={() => close(p.id)} className="btn-hazard bg-[#d9b3ff] text-[#0a133f] flex-1 text-xs py-1">PANIC</button>
              <button onClick={() => close(p.id)} className="btn-hazard bg-white text-[#0a133f] flex-1 text-xs py-1">IGNORE</button>
            </div>
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default FakeWarningPopups;
